import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';

import OneClickButton from '../../../../components/form/button';
import {
  Panel, PanelHeader, PanelBody, PanelFooter,
} from '../../../../components/panel/panel';
import addNotification from '../../../../components/notification';

import ROUTES from '../../../../config/routes';

import {
  createDailyLoad, getDailyLoad, updateDailyLoad,
} from '../../../../app/store/actions/dailyLoads';
import Form from '../../../../components/form/form';

import { getBranch, getBranchesOptions } from '../../../../app/store/actions/branches';

class DailyLoadForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'detail',
      position: '',
      description: '',
      branch: '',
      branchName: '',
      listBranch: [],
      collectionTime: '',
      collectionDayOption: '',
      cutOffTime: '',
      active: true,
      notes: '',
      checkSunday: false,
      checkMonday: false,
      checkTuesday: false,
      checkWednesday: false,
      checkThursday: false,
      checkFriday: false,
      checkSaturday: false,
      checkDayOne: false,
      checkDayTwo: false,
      checkDayThree: false,
      checkDayFour: false,
      checkDayFive: false,
      checkDaySix: false,
      checkDaySeven: false,
      checkDayEight: false,
      checkDayNine: false,
      checkDayTen: false,
      checkDayEleven: false,
      checkDayTwelve: false,
      checkDayThirteen: false,
      checkDayFourteen: false,
      checkDayFifteen: false,
      checkDaySixteen: false,
      checkDaySeventeen: false,
      checkDayEighteen: false,
      checkDayNineteen: false,
      checkDayTwenty: false,
      checkDayTwentyOne: false,
      checkDayTwentyTwo: false,
      checkDayTwentyThree: false,
      checkDayTwentyFour: false,
      checkDayTwentyFive: false,
      checkDayTwentySix: false,
      checkDayTwentySeven: false,
      checkDayTwentyEight: false,
      checkDayTwentyNine: false,
      checkDayThirty: false,
      checkDayThirtyOne: false,
      disablePosition: true,
      disableDescription: true,
      disableWeekDaysForCollection: true,
      disableMonthDaysForCollection: true,
      disableCollectionTime: true,
      disableCollectionDayOption: true,
      disableCutOffTime: true,
      disableActive: true,
      disableNotes: true,
      disableBranch: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
    };
  }

  async componentDidMount() {
    await this.setMode();
    const listBranch = await this.props.getBranchesOptions();

    if (this.state.mode !== 'create') {
      await this.getDailyLoadSelected();
    }

    this.setState({
      listBranch,
    });
  }

  getDailyLoadSelected = async () => {
    if (this.props.location.state.dailyLoad) {
      const { dailyLoad } = this.props.location.state;

      const dailyLoadSelected = await this.props.getDailyLoad(dailyLoad.id);

      if (dailyLoadSelected) {
        if (dailyLoadSelected.collectionDayOption === 3) {
          const collectionDayValues = JSON.parse(dailyLoadSelected.collectionDayValues);

          this.setState({
            checkSunday: collectionDayValues.includes(0), // Domingo (0)
            checkMonday: collectionDayValues.includes(1), // Segunda-feira (1)
            checkTuesday: collectionDayValues.includes(2), // Terça-feira (2)
            checkWednesday: collectionDayValues.includes(3), // Quarta-feira (3)
            checkThursday: collectionDayValues.includes(4), // Quinta-feira (4)
            checkFriday: collectionDayValues.includes(5), // Sexta-feira (5)
            checkSaturday: collectionDayValues.includes(6), // Sábado (6)
          });
        } else if (dailyLoadSelected.collectionDayOption === 4) {
          const collectionDayValues = JSON.parse(dailyLoadSelected.collectionDayValues);

          this.setState({
            checkDayOne: collectionDayValues.includes(1),
            checkDayTwo: collectionDayValues.includes(2),
            checkDayThree: collectionDayValues.includes(3),
            checkDayFour: collectionDayValues.includes(4),
            checkDayFive: collectionDayValues.includes(5),
            checkDaySix: collectionDayValues.includes(6),
            checkDaySeven: collectionDayValues.includes(7),
            checkDayEight: collectionDayValues.includes(8),
            checkDayNine: collectionDayValues.includes(9),
            checkDayTen: collectionDayValues.includes(10),
            checkDayEleven: collectionDayValues.includes(11),
            checkDayTwelve: collectionDayValues.includes(12),
            checkDayThirteen: collectionDayValues.includes(13),
            checkDayFourteen: collectionDayValues.includes(14),
            checkDayFifteen: collectionDayValues.includes(15),
            checkDaySixteen: collectionDayValues.includes(16),
            checkDaySeventeen: collectionDayValues.includes(17),
            checkDayEighteen: collectionDayValues.includes(18),
            checkDayNineteen: collectionDayValues.includes(19),
            checkDayTwenty: collectionDayValues.includes(20),
            checkDayTwentyOne: collectionDayValues.includes(21),
            checkDayTwentyTwo: collectionDayValues.includes(22),
            checkDayTwentyThree: collectionDayValues.includes(23),
            checkDayTwentyFour: collectionDayValues.includes(24),
            checkDayTwentyFive: collectionDayValues.includes(25),
            checkDayTwentySix: collectionDayValues.includes(26),
            checkDayTwentySeven: collectionDayValues.includes(27),
            checkDayTwentyEight: collectionDayValues.includes(28),
            checkDayTwentyNine: collectionDayValues.includes(29),
            checkDayThirty: collectionDayValues.includes(30),
            checkDayThirtyOne: collectionDayValues.includes(31),
          });
        }

        this.setState({
          dailyLoadId: dailyLoadSelected.id,
          position: dailyLoadSelected.position,
          description: dailyLoadSelected.description,
          branch: dailyLoadSelected.branchCode,
          branchName: dailyLoadSelected.branch.name,
          collectionTime: dailyLoadSelected.collectionTime,
          collectionDayOption: dailyLoadSelected.collectionDayOption,
          cutOffTime: dailyLoadSelected.cutOffTime,
          active: dailyLoadSelected.active,
          notes: dailyLoadSelected.note,
        });
      }
    }
  };

  setMode = () => {
    let mode = '';
    if (this.props.isCreate) mode = 'create';
    else if (this.props.isCopy) mode = 'copy';
    else if (this.props.isEdit) mode = 'edit';
    else if (this.props.isDetail) mode = 'detail';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disablePosition: false,
        disableDescription: false,
        disableWeekDaysForCollection: false,
        disableMonthDaysForCollection: false,
        disableCollectionTime: false,
        disableCollectionDayOption: false,
        disableCutOffTime: false,
        disableActive: false,
        disableNotes: false,
        disableBranch: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disablePosition: true,
        disableDescription: false,
        disableWeekDaysForCollection: false,
        disableMonthDaysForCollection: false,
        disableCollectionTime: false,
        disableCollectionDayOption: false,
        disableCutOffTime: false,
        disableActive: false,
        disableNotes: false,
        disableBranch: true,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    if (attr === 'collectionDayOption') {
      this.setState({
        [`${attr}`]: value,
      });

      if (value !== 3) {
        this.setState({
          checkSunday: false,
          checkMonday: false,
          checkTuesday: false,
          checkWednesday: false,
          checkThursday: false,
          checkFriday: false,
          checkSaturday: false,
        });
      }
      if (value !== 4) {
        this.setState({
          checkDayOne: false,
          checkDayTwo: false,
          checkDayThree: false,
          checkDayFour: false,
          checkDayFive: false,
          checkDaySix: false,
          checkDaySeven: false,
          checkDayEight: false,
          checkDayNine: false,
          checkDayTen: false,
          checkDayEleven: false,
          checkDayTwelve: false,
          checkDayThirteen: false,
          checkDayFourteen: false,
          checkDayFifteen: false,
          checkDaySixteen: false,
          checkDaySeventeen: false,
          checkDayEighteen: false,
          checkDayNineteen: false,
          checkDayTwenty: false,
          checkDayTwentyOne: false,
          checkDayTwentyTwo: false,
          checkDayTwentyThree: false,
          checkDayTwentyFour: false,
          checkDayTwentyFive: false,
          checkDayTwentySix: false,
          checkDayTwentySeven: false,
          checkDayTwentyEight: false,
          checkDayTwentyNine: false,
          checkDayThirty: false,
          checkDayThirtyOne: false,
        });
      }
    } else if (/^checkDay(One|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|TwentyOne|ThirtyOne|\d{1,2})$/.test(attr)) {
      // Verifica se o atributo é 'checkDayOne' até 'checkDayThirtyOne' usando regex
      this.setState({
        [`${attr}`]: value,
      });
    } else if (attr === 'checkSunday'
               || attr === 'checkMonday'
               || attr === 'checkTuesday'
               || attr === 'checkWednesday'
               || attr === 'checkThursday'
               || attr === 'checkFriday'
               || attr === 'checkSaturday') {
      this.setState({
        [`${attr}`]: value,
      });
    } else {
      await this.setState({
        [`${attr}`]: value,
      });
    }
  };

  setValueDrop = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value ? value.value : null,
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  createDailyLoadSubmit = async () => {
    const {
      position, description, branch, collectionTime,
      collectionDayOption, cutOffTime, active, notes,
      checkSunday, checkMonday, checkTuesday, checkWednesday, checkThursday, checkFriday, checkSaturday,
      checkDayOne, checkDayTwo, checkDayThree, checkDayFour, checkDayFive,
      checkDaySix, checkDaySeven, checkDayEight, checkDayNine, checkDayTen, checkDayEleven,
      checkDayTwelve, checkDayThirteen, checkDayFourteen, checkDayFifteen,
      checkDaySixteen, checkDaySeventeen, checkDayEighteen, checkDayNineteen,
      checkDayTwenty, checkDayTwentyOne, checkDayTwentyTwo, checkDayTwentyThree,
      checkDayTwentyFour, checkDayTwentyFive, checkDayTwentySix, checkDayTwentySeven,
      checkDayTwentyEight, checkDayTwentyNine, checkDayThirty, checkDayThirtyOne,
    } = this.state;

    let result = [];

    if (Number(collectionDayOption) === 3) {
      const weekDays = [
        { check: checkSunday, value: 0 }, // Domingo
        { check: checkMonday, value: 1 }, // Segunda-feira
        { check: checkTuesday, value: 2 }, // Terça-feira
        { check: checkWednesday, value: 3 }, // Quarta-feira
        { check: checkThursday, value: 4 }, // Quinta-feira
        { check: checkFriday, value: 5 }, // Sexta-feira
        { check: checkSaturday, value: 6 }, // Sábado
      ];

      result = weekDays
        .filter((day) => day.check)
        .map((day) => day.value);
    } else if (Number(collectionDayOption) === 4) {
      const monthDays = [
        { check: checkDayOne, value: 1 },
        { check: checkDayTwo, value: 2 },
        { check: checkDayThree, value: 3 },
        { check: checkDayFour, value: 4 },
        { check: checkDayFive, value: 5 },
        { check: checkDaySix, value: 6 },
        { check: checkDaySeven, value: 7 },
        { check: checkDayEight, value: 8 },
        { check: checkDayNine, value: 9 },
        { check: checkDayTen, value: 10 },
        { check: checkDayEleven, value: 11 },
        { check: checkDayTwelve, value: 12 },
        { check: checkDayThirteen, value: 13 },
        { check: checkDayFourteen, value: 14 },
        { check: checkDayFifteen, value: 15 },
        { check: checkDaySixteen, value: 16 },
        { check: checkDaySeventeen, value: 17 },
        { check: checkDayEighteen, value: 18 },
        { check: checkDayNineteen, value: 19 },
        { check: checkDayTwenty, value: 20 },
        { check: checkDayTwentyOne, value: 21 },
        { check: checkDayTwentyTwo, value: 22 },
        { check: checkDayTwentyThree, value: 23 },
        { check: checkDayTwentyFour, value: 24 },
        { check: checkDayTwentyFive, value: 25 },
        { check: checkDayTwentySix, value: 26 },
        { check: checkDayTwentySeven, value: 27 },
        { check: checkDayTwentyEight, value: 28 },
        { check: checkDayTwentyNine, value: 29 },
        { check: checkDayThirty, value: 30 },
        { check: checkDayThirtyOne, value: 31 },
      ];

      result = monthDays
        .filter((day) => day.check)
        .map((day) => day.value);
    }

    const collectionDayValues = JSON.stringify(result);

    try {
      const newDailyLoad = await this.props.createDailyLoad({
        position,
        description,
        branch,
        collectionTime,
        collectionDayOption,
        collectionDayValues,
        cutOffTime,
        active,
        notes,
      });

      if (newDailyLoad) {
        await addNotification(
          'success',
          I18n.t('BEE3933' /* Carregamentos Diários */),
          I18n.t('BEE3962' /* Carregamento diário incluído com sucesso. */),
          'top-right',
        );

        this.props.history.push(ROUTES.DAILY_SHIPMENT_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE3933' /* Carregamentos Diários */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE3933' /* Carregamentos Diários */),
            I18n.t('BEE3963' /* Erro ao incluir o Carregamento Diário */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE3933' /* Carregamentos Diários */),
          I18n.t('BEE3963' /* Erro ao incluir o Carregamento Diário */),
          'top-right',
        );
      }
    }
  };

  updateDailyLoadSubmit = async () => {
    const {
      description, collectionTime, collectionDayOption, cutOffTime, active, notes, dailyLoadId,
      checkSunday, checkMonday, checkTuesday, checkWednesday, checkThursday, checkFriday, checkSaturday,
      checkDayOne, checkDayTwo, checkDayThree, checkDayFour, checkDayFive,
      checkDaySix, checkDaySeven, checkDayEight, checkDayNine, checkDayTen, checkDayEleven,
      checkDayTwelve, checkDayThirteen, checkDayFourteen, checkDayFifteen,
      checkDaySixteen, checkDaySeventeen, checkDayEighteen, checkDayNineteen,
      checkDayTwenty, checkDayTwentyOne, checkDayTwentyTwo, checkDayTwentyThree,
      checkDayTwentyFour, checkDayTwentyFive, checkDayTwentySix, checkDayTwentySeven,
      checkDayTwentyEight, checkDayTwentyNine, checkDayThirty, checkDayThirtyOne,
    } = this.state;

    try {
      let result = [];

      if (Number(collectionDayOption) === 3) {
        const weekDays = [
          { check: checkSunday, value: 0 }, // Domingo
          { check: checkMonday, value: 1 }, // Segunda-feira
          { check: checkTuesday, value: 2 }, // Terça-feira
          { check: checkWednesday, value: 3 }, // Quarta-feira
          { check: checkThursday, value: 4 }, // Quinta-feira
          { check: checkFriday, value: 5 }, // Sexta-feira
          { check: checkSaturday, value: 6 }, // Sábado
        ];

        result = weekDays
          .filter((day) => day.check)
          .map((day) => day.value);
      } else if (Number(collectionDayOption) === 4) {
        const monthDays = [
          { check: checkDayOne, value: 1 },
          { check: checkDayTwo, value: 2 },
          { check: checkDayThree, value: 3 },
          { check: checkDayFour, value: 4 },
          { check: checkDayFive, value: 5 },
          { check: checkDaySix, value: 6 },
          { check: checkDaySeven, value: 7 },
          { check: checkDayEight, value: 8 },
          { check: checkDayNine, value: 9 },
          { check: checkDayTen, value: 10 },
          { check: checkDayEleven, value: 11 },
          { check: checkDayTwelve, value: 12 },
          { check: checkDayThirteen, value: 13 },
          { check: checkDayFourteen, value: 14 },
          { check: checkDayFifteen, value: 15 },
          { check: checkDaySixteen, value: 16 },
          { check: checkDaySeventeen, value: 17 },
          { check: checkDayEighteen, value: 18 },
          { check: checkDayNineteen, value: 19 },
          { check: checkDayTwenty, value: 20 },
          { check: checkDayTwentyOne, value: 21 },
          { check: checkDayTwentyTwo, value: 22 },
          { check: checkDayTwentyThree, value: 23 },
          { check: checkDayTwentyFour, value: 24 },
          { check: checkDayTwentyFive, value: 25 },
          { check: checkDayTwentySix, value: 26 },
          { check: checkDayTwentySeven, value: 27 },
          { check: checkDayTwentyEight, value: 28 },
          { check: checkDayTwentyNine, value: 29 },
          { check: checkDayThirty, value: 30 },
          { check: checkDayThirtyOne, value: 31 },
        ];

        result = monthDays
          .filter((day) => day.check)
          .map((day) => day.value);
      }

      const collectionDayValues = JSON.stringify(result);

      const updUser = await this.props.updateDailyLoad({
        dailyLoadId,
        description,
        collectionTime,
        collectionDayOption,
        collectionDayValues,
        cutOffTime,
        active,
        notes,
      });

      if (updUser) {
        await addNotification(
          'success',
          I18n.t('BEE3965' /* Atualizar Carregamento Diário */),
          I18n.t('BEE3966' /* Atualização do Carregamento Diário efetuada com sucesso! */),
          'top-right',
        );

        this.props.history.push(ROUTES.DAILY_SHIPMENT_LIST);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE3965' /* Atualizar Carregamento Diário */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE3965' /* Atualizar Carregamento Diário */),
            I18n.t('BEE3967' /* Erro ao atualizar o Carregamento Diário */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE3965' /* Atualizar Carregamento Diário */),
          I18n.t('BEE3967' /* Erro ao atualizar o Carregamento Diário */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      position, description, branch, branchName, listBranch, collectionDayOption,
      collectionTime, cutOffTime, active, notes, disableWeekDaysForCollection, disableMonthDaysForCollection,
      checkSunday, checkMonday, checkTuesday, checkWednesday, checkThursday, checkFriday, checkSaturday,
      checkDayOne, checkDayTwo, checkDayThree, checkDayFour, checkDayFive,
      checkDaySix, checkDaySeven, checkDayEight, checkDayNine, checkDayTen, checkDayEleven,
      checkDayTwelve, checkDayThirteen, checkDayFourteen, checkDayFifteen,
      checkDaySixteen, checkDaySeventeen, checkDayEighteen, checkDayNineteen,
      checkDayTwenty, checkDayTwentyOne, checkDayTwentyTwo, checkDayTwentyThree,
      checkDayTwentyFour, checkDayTwentyFive, checkDayTwentySix, checkDayTwentySeven,
      checkDayTwentyEight, checkDayTwentyNine, checkDayThirty, checkDayThirtyOne,
    } = this.state;

    const {
      mode, disablePosition, disableDescription, disableCollectionDayOption,
      disableCollectionTime, disableCutOffTime, disableActive, disableNotes, disableBranch,
      showCancel, showCreate, showUpdate,
    } = this.state;

    let title = '';

    let listCollectionDay = [];

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE3946' /* Novo Carregamento Diário */);

      listCollectionDay = [
        {
          value: 1,
          label: I18n.t('BEE3941' /* Todos os dias do mês */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 2,
          label: I18n.t('BEE3942' /* Dias úteis da semana - Segunda a Sexta */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 3,
          label: I18n.t('BEE3943' /* Dia específico da semana (escolha um ou vários) */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 4,
          label: I18n.t('BEE3944' /* Dia específico do mês (escolha um ou vários) */),
          disabled: disableCollectionDayOption,
        },
      ];
    } else if (mode === 'edit') {
      title = I18n.t('BEE3947' /* Editar Carregamento Diário */);

      listCollectionDay = [
        {
          value: 1,
          label: I18n.t('BEE3941' /* Todos os dias do mês */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 2,
          label: I18n.t('BEE3942' /* Dias úteis da semana - Segunda a Sexta */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 3,
          label: I18n.t('BEE3943' /* Dia específico da semana (escolha um ou vários) */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 4,
          label: I18n.t('BEE3944' /* Dia específico do mês (escolha um ou vários) */),
          disabled: disableCollectionDayOption,
        },
      ];
    } else if (mode === 'detail') {
      title = I18n.t('BEE3933' /* Carregamentos Diários */);

      listCollectionDay = [
        {
          value: 1,
          label: I18n.t('BEE3941' /* Todos os dias do mês */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 2,
          label: I18n.t('BEE3942' /* Dias úteis da semana - Segunda a Sexta */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 3,
          label: I18n.t('BEE3943' /* Dia específico da semana (escolha um ou vários) */),
          disabled: disableCollectionDayOption,
        },
        {
          value: 4,
          label: I18n.t('BEE3944' /* Dia específico do mês (escolha um ou vários) */),
          disabled: disableCollectionDayOption,
        },
      ];
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE3933' /* Carregamentos Diários */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <form>
              <Panel>
                <PanelHeader noButton />
                <PanelBody>
                  <Form
                    noPanel
                    setValue={this.setValue}
                    setValueDrop={this.setValueDrop}
                    inputs={(formContext) => ([
                      formContext.createInput(
                        position,
                        'position',
                        `${I18n.t('BEE3937' /* Posição */)}:`,
                        I18n.t('BEE3949' /* Relate a posição */),
                        'number',
                        true,
                        disablePosition,
                      ),
                      formContext.createInput(
                        description,
                        'description',
                        `${I18n.t('BEE1897' /* Descrição */)}:`,
                        I18n.t('BEE3477' /* Informe a descrição */),
                        'text',
                        true,
                        disableDescription,
                      ),
                      disableBranch
                        ? formContext.createInput(
                          branchName,
                          'branch',
                          `${I18n.t('BEE145' /* Filial */)}:`,
                          '',
                          'text',
                          true,
                          disableBranch,
                        )
                        : formContext.createSelectDropDown(
                          { value: branch, label: branchName },
                          'branch',
                          `${I18n.t('BEE145' /* Filial */)}:`,
                          listBranch,
                          disableBranch,
                          undefined,
                          undefined,
                          undefined,
                          undefined,
                          undefined,
                          true,
                        ),
                      formContext.createRadioButtons(
                        listCollectionDay,
                        collectionDayOption,
                        'collectionDayOption',
                        `${I18n.t('BEE3950' /* Data de Coleta */)}:`,
                        'form-check',
                        undefined,
                        'd-flex flex-column justify-content-center',
                        ['col-md-4'],
                      ),
                      // Verificação condicional para collectionTime === 3 ou 4
                      Number(collectionDayOption) === 3 && formContext.createCheckBoxes(
                        [
                          {
                            value: checkSunday,
                            label: I18n.t('BEE668' /* Domingo */),
                            attr: 'checkSunday',
                            disabled: disableWeekDaysForCollection,
                          },
                          {
                            value: checkMonday,
                            label: I18n.t('BEE662' /* Segunda-feira */),
                            attr: 'checkMonday',
                            disabled: disableWeekDaysForCollection,
                          },
                          {
                            value: checkTuesday,
                            label: I18n.t('BEE663' /* Terça-feira */),
                            attr: 'checkTuesday',
                            disabled: disableWeekDaysForCollection,
                          },
                          {
                            value: checkWednesday,
                            label: I18n.t('BEE664' /* Quarta-feira */),
                            attr: 'checkWednesday',
                            disabled: disableWeekDaysForCollection,
                          },
                          {
                            value: checkThursday,
                            label: I18n.t('BEE665' /* Quinta-feira */),
                            attr: 'checkThursday',
                            disabled: disableWeekDaysForCollection,
                          },
                          {
                            value: checkFriday,
                            label: I18n.t('BEE666' /* Sexta-feira */),
                            attr: 'checkFriday',
                            disabled: disableWeekDaysForCollection,
                          },
                          {
                            value: checkSaturday,
                            label: I18n.t('BEE667' /* Sábado */),
                            attr: 'checkSaturday',
                            disabled: disableWeekDaysForCollection,
                          },
                        ],
                        undefined,
                        undefined,
                        ['col-md-2', 'col-md-12'],
                        true,
                      ),
                      Number(collectionDayOption) === 4 && formContext.createCheckBoxes(
                        [
                          {
                            value: checkDayOne,
                            label: '01',
                            attr: 'checkDayOne',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwo,
                            label: '02',
                            attr: 'checkDayTwo',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayThree,
                            label: '03',
                            attr: 'checkDayThree',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayFour,
                            label: '04',
                            attr: 'checkDayFour',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayFive,
                            label: '05',
                            attr: 'checkDayFive',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDaySix,
                            label: '06',
                            attr: 'checkDaySix',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDaySeven,
                            label: '07',
                            attr: 'checkDaySeven',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayEight,
                            label: '08',
                            attr: 'checkDayEight',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayNine,
                            label: '09',
                            attr: 'checkDayNine',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTen,
                            label: '10',
                            attr: 'checkDayTen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayEleven,
                            label: '11',
                            attr: 'checkDayEleven',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwelve,
                            label: '12',
                            attr: 'checkDayTwelve',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayThirteen,
                            label: '13',
                            attr: 'checkDayThirteen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayFourteen,
                            label: '14',
                            attr: 'checkDayFourteen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayFifteen,
                            label: '15',
                            attr: 'checkDayFifteen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDaySixteen,
                            label: '16',
                            attr: 'checkDaySixteen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDaySeventeen,
                            label: '17',
                            attr: 'checkDaySeventeen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayEighteen,
                            label: '18',
                            attr: 'checkDayEighteen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayNineteen,
                            label: '19',
                            attr: 'checkDayNineteen',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwenty,
                            label: '20',
                            attr: 'checkDayTwenty',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyOne,
                            label: '21',
                            attr: 'checkDayTwentyOne',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyTwo,
                            label: '22',
                            attr: 'checkDayTwentyTwo',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyThree,
                            label: '23',
                            attr: 'checkDayTwentyThree',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyFour,
                            label: '24',
                            attr: 'checkDayTwentyFour',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyFive,
                            label: '25',
                            attr: 'checkDayTwentyFive',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentySix,
                            label: '26',
                            attr: 'checkDayTwentySix',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentySeven,
                            label: '27',
                            attr: 'checkDayTwentySeven',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyEight,
                            label: '28',
                            attr: 'checkDayTwentyEight',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayTwentyNine,
                            label: '29',
                            attr: 'checkDayTwentyNine',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayThirty,
                            label: '30',
                            attr: 'checkDayThirty',
                            disabled: disableMonthDaysForCollection,
                          },
                          {
                            value: checkDayThirtyOne,
                            label: '31',
                            attr: 'checkDayThirtyOne',
                            disabled: disableMonthDaysForCollection,
                          },
                        ],
                        undefined,
                        undefined,
                        ['col-md-2', 'col-md-12'],
                        true,
                      ),
                      formContext.createInput(
                        collectionTime,
                        'collectionTime',
                        `${I18n.t('BEE3956' /* Horário da Coleta */)}:`,
                        I18n.t('BEE3957' /* Informe o horário da coleta. */),
                        'time',
                        false,
                        disableCollectionTime,
                      ),
                      formContext.createInput(
                        cutOffTime,
                        'cutOffTime',
                        `${I18n.t('BEE3958' /* Horário de Corte */)}:`,
                        I18n.t('BEE3959' /* Informe o horário de corte. */),
                        'time',
                        false,
                        disableCutOffTime,
                      ),
                      formContext.createSelectDropDown(
                        {
                          value: active,
                          label: active ? I18n.t('BEE499' /* Ativo */)
                            : I18n.t('BEE1137' /* Inativo */),
                        },
                        'active',
                        `${I18n.t('BEE224' /* Status */)}:`,
                        [
                          { value: 1, label: I18n.t('BEE499' /* Ativo */) },
                          { value: 0, label: I18n.t('BEE1137' /* Inativo */) },
                        ],
                        disableActive,
                      ),
                      formContext.createInput(
                        notes,
                        'notes',
                        `${I18n.t('BEE3960' /* Observações */)}:`,
                        I18n.t('BEE3961' /* Informe as observações. */),
                        'text',
                        false,
                        disableNotes,
                      ),
                    ])}
                  />
                </PanelBody>
                <PanelFooter>
                  <Link to={{ pathname: ROUTES.DAILY_SHIPMENT_LIST, state: { dice: this.props.location.dice } }}>
                    {(showCancel
                      ? (
                        <OneClickButton
                          type="submit"
                          className="btn btn-120 btn-white p-5 m-5"
                        >
                          {I18n.t('BEE99' /* Cancelar */)}
                        </OneClickButton>
                      )
                      : (
                        <OneClickButton
                          type="submit"
                          className="btn btn-120 btn-white p-5 m-5"
                        >
                          {I18n.t('BEE137' /* Voltar */)}
                        </OneClickButton>
                      ))}
                  </Link>
                  {(showCreate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createDailyLoadSubmit()}
                    >
                      {I18n.t('BEE138' /* Criar */)}

                    </OneClickButton>
                    )
                  )}
                  {(showUpdate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateDailyLoadSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}

                    </OneClickButton>
                    )
                  )}
                </PanelFooter>
              </Panel>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getDailyLoad: (dailyLoadId) => dispatch(getDailyLoad(dailyLoadId)),
  createDailyLoad: (dailyLoad) => dispatch(createDailyLoad(dailyLoad)),
  updateDailyLoad: (dailyLoad) => dispatch(updateDailyLoad(dailyLoad)),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  getBranch: (branchCode) => dispatch(getBranch(branchCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DailyLoadForm));
